 
<div class="forex-more-container">
   
    <div class="section-header" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="title">Forex Approval</div>
        <div class="cursor" (click)="closeDialog()">
            <span><svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px"
                    fill="#FFF">
                    <path
                        d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
                </svg></span>
        </div>
    </div>
    
    <div class="data-card">
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Employee Name</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData.employeename}}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Email</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data email">: {{forexMoreData.employeeemailid}}</div>
            </div>
        </div>
       
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">PS No</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData.psno}}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Employee Base location</div>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-6">
                <div class="item-data text-space">: {{forexMoreData?.employeebaselocation}}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Travelling Country</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData?.country}}</div>
            </div>
        </div>
         <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Amount Required In Cash</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{ getFormattedAmountsForEmployee(forexMoreData).cash.join(', ') }}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Amount Required on Card</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{ getFormattedAmountsForEmployee(forexMoreData).card.join(', ') }}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Cost Code</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData?.costcode}}</div>
            </div>
        </div>
        <!-- <div class="row mb-1 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Type</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: Billable</div>
            </div>
        </div> -->
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Travelling Duration</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data text-space">: {{forexMoreData?.travelstartdate | date:'dd-MMM-yy'}} to {{forexMoreData?.travelenddate | date:'dd-MMM-yy'}} ({{forexMoreData?.duration}} days)</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Date Of Birth</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData?.dateofbirth | date:'dd-MMM-yy'}}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Mobile No</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData?.cellno}}</div>
            </div>
        </div>
        <div class="row mb-2 mb-md-4" *ngIf="forexMoreData?.alternatePhoneNumber">
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="row-data">Alternate Mobile No</div>
            </div>
            <div class="col-6 col-md-5 col-lg-5 col-xl-5">
                <div class="item-data">: {{forexMoreData?.alternatePhoneNumber}}</div>
            </div>
        </div>
        
        
        <div class="button-container">
            <div class="tooltip-container">
            <button class="viewBtn" (click)="redirectTo(forexMoreData?.url)">
               <span class="btn-content">
                    <img src="assets/images/approvals/power.svg" class="" alt="approve" />
                    <span>More</span>
              </span>

            </button>
            <span class="tooltip-text">Redirects to Forex App</span>
            </div>
            <button class="approve-button" [disabled]="isDisabled">Approve</button>
        </div>
    </div>
</div>